import { PointsVaultUserLoginPayload } from "../../types";

export const pointsVaultUserLoginModelCreator = (response: PointsVaultUserLoginPayload): PointsVaultUserLoginPayload =>
  response;
